export class OwnerPropertyAddressResultDto {
  address: string;
  city: string;
  state: string;
  stateCode: string;
  zip: string;
  country: string;
  countryCode: string;
}
